import React, { useState } from "react";
import {
    Box,
    Input,
    FormControl,
    FormLabel,
    Button,
    Flex,
    Text,
    NumberInput,
    NumberInputField,

    InputGroup,
    InputLeftAddon,
    Select,
    Checkbox,
    Collapse,
    Divider,
} from "@chakra-ui/react";
import { LuAlignCenter, LuAlignLeft, LuAlignRight, LuBold, LuChevronDown, LuChevronUp, LuGripHorizontal, LuGripVertical, LuItalic, LuUnderline } from "react-icons/lu";

// Font size options for the dropdown
const fontSizeOptions = [
    "12", "14", "16", "18", "20", "24", "28", "32", "36", "48"
];

// Default button props
const getDefaultButtonProps = () => ({
    text: "Button Text",
    link: "",
    fontSize: "16",
    fontColor: "#000000",
    backgroundColor: "#2563eb",
    cornerRadius: "0",
    alignment: "center",
    bold: false,
    italic: false,
    underline: false,
    addBorder: false,
    borderColor: "#000000",
    borderWeight: "1",
    marginTop: "10",
    marginRight: "0",
    marginBottom: "0",
    marginLeft: "0"
});

const ButtonBlockEditor = ({ block, onChange }) => {
    const [showAdvancedOptions1, setShowAdvancedOptions1] = useState(false);
    const [showAdvancedOptions2, setShowAdvancedOptions2] = useState(false);
    const [showAdvancedOptions3, setShowAdvancedOptions3] = useState(false);

    // Initialize or get button data
    const buttons = block.props.buttons || [getDefaultButtonProps()];
    const buttonCount = block.props.buttonCount || 1;
    const buttonPlacement = block.props.buttonPlacement || "horizontal";

    const handleButtonCountChange = (count) => {
        // Create or adjust buttons array based on count
        let updatedButtons = [...buttons];

        if (count > buttons.length) {
            // Add new buttons
            for (let i = buttons.length; i < count; i++) {
                updatedButtons.push(getDefaultButtonProps());
            }
        } else if (count < buttons.length) {
            // Remove excess buttons
            updatedButtons = updatedButtons.slice(0, count);
        }

        onChange({
            ...block,
            props: {
                ...block.props,
                buttonCount: count,
                buttons: updatedButtons
            }
        });
    };

    const handleButtonPlacementChange = (placement) => {
        onChange({
            ...block,
            props: {
                ...block.props,
                buttonPlacement: placement
            }
        });
    };

    const updateButtonProp = (index, propName, value) => {
        const updatedButtons = [...buttons];
        updatedButtons[index] = {
            ...updatedButtons[index],
            [propName]: value
        };

        onChange({
            ...block,
            props: {
                ...block.props,
                buttons: updatedButtons
            }
        });
    };

    const handleAlignmentChange = (index, alignment) => {
        updateButtonProp(index, 'alignment', alignment);
    };

    const handleFormatChange = (index, format) => {
        const currentValue = buttons[index][format];
        updateButtonProp(index, format, !currentValue);
    };

    const handleBorderToggle = (index, checked) => {
        updateButtonProp(index, 'addBorder', checked);
    };
   
    // Render a single button editor
    const renderButtonEditor = (buttonData, index) => {
        const showAdvancedOptions = index === 0 ? showAdvancedOptions1 :
            index === 1 ? showAdvancedOptions2 : showAdvancedOptions3;
        const setShowAdvancedOptions = index === 0 ? setShowAdvancedOptions1 :
            index === 1 ? setShowAdvancedOptions2 : setShowAdvancedOptions3;

        return (
            <Box key={index} mb={5} p={3} borderRadius="md" >
                <Text fontWeight="bold" mb={3}>Button {index + 1}</Text>

                <FormControl mb={3}>
                    <FormLabel fontSize="sm">Button Text</FormLabel>
                    <Input
                        value={buttonData.text}
                        placeholder="Button Text"
                        onChange={(e) => updateButtonProp(index, 'text', e.target.value)}
                        style={{ backgroundColor: "white", border: "1px solid #CCCCCC", color: "#4A5568" }}

                    />
                </FormControl>

                <FormControl mb={3}>
                    <FormLabel fontSize="sm">Link</FormLabel>
                    <Input
                        value={buttonData.link}
                        placeholder="Please Enter Button Link"
                        onChange={(e) => updateButtonProp(index, 'link', e.target.value)}
                        style={{ backgroundColor: "white", border: "1px solid #CCCCCC", color: "#4A5568" }}

                    />
                </FormControl>

                <Flex mt={4} mb={2} gap={2} flexWrap="wrap">
                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Font Color</FormLabel>
                       <Flex style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white" }}>
                            <Input
                                type="text"
                                value={buttonData.fontColor}
                                style={{ border: "none" }}

                                size="sm"
                                onChange={(e) => updateButtonProp(index, 'fontColor', e.target.value)}
                                width="100px"
                            />
                            <Input
                                type="color"
                                value={buttonData.fontColor}
                                size="sm"
                                p={0}
                                height="32px"
                                width="32px"
                                style={{ border: "none" }}
                                ml={1}
                                onChange={(e) => updateButtonProp(index, 'fontColor', e.target.value)}
                            />
                        </Flex>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Background Color</FormLabel>
                      <Flex style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white" }}>
                            <Input
                                type="text"
                                value={buttonData.backgroundColor}
                                size="sm"
                                
                                style={{ border: "none" }}
                                onChange={(e) => updateButtonProp(index, 'backgroundColor', e.target.value)}
                                width="100px"
                            />
                            <Input
                                type="color"
                                value={buttonData.backgroundColor}
                                size="sm"
                                p={0}
                                height="32px"
                                width="32px"
                                ml={1}
                                style={{ border: "none" }}
                                onChange={(e) => updateButtonProp(index, 'backgroundColor', e.target.value)}
                            />
                        </Flex>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Corner Radius</FormLabel>
                        <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                            <NumberInput
                                value={buttonData.cornerRadius}
                                min={0}
                                max={50}
                                onChange={(value) => updateButtonProp(index, 'cornerRadius', value)}
                                style={{ border: "none !important" }}


                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                            <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>
                </Flex>

                <Flex mt={4} mb={2} gap={2} flexWrap="wrap">
                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Font Size</FormLabel>
                        <Select
                            size="sm"
                            value={buttonData.fontSize}
                            onChange={(e) => updateButtonProp(index, 'fontSize', e.target.value)}
                            style={{ backgroundColor: "white", border: "1px solid #CCCCCC", color: "#4A5568" }}

                        >
                            {fontSizeOptions.map(size => (
                                <option key={size} value={size}>{size}</option>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl maxW="150px">
                        <FormLabel fontSize="xs" mb={1}>Alignment</FormLabel>
                        <Flex>
                            <Button
                                size="sm"
                                onClick={() => handleAlignmentChange(index, 'left')}
                                bg={buttonData.alignment === 'left' ? 'blue.100' : 'white'}
                                borderRadius="md"
                                borderRightRadius="0"
                                style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}

                                flex="1"
                            >
                                <LuAlignLeft />
                            </Button>
                            <Button
                                size="sm"
                                onClick={() => handleAlignmentChange(index, 'center')}
                                bg={buttonData.alignment === 'center' ? 'blue.100' : 'white'}
                                borderRadius="0"
                                style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}

                                flex="1"
                            >
                                <LuAlignCenter />
                            </Button>
                            <Button
                                size="sm"
                                onClick={() => handleAlignmentChange(index, 'right')}
                                bg={buttonData.alignment === 'right' ? 'blue.100' : 'white'}
                                borderLeftRadius="0"
                                style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}


                                flex="1"
                            >
                                <LuAlignRight />
                            </Button>
                        </Flex>
                    </FormControl>

                    <FormControl maxW="150px">
                        <FormLabel fontSize="xs" mb={1}>Format</FormLabel>
                        <Flex>
                            <Button
                                size="sm"
                                onClick={() => handleFormatChange(index, 'bold')}
                                bg={buttonData.bold ? 'blue.100' : 'white'}
                                borderRadius="md"
                                borderRightRadius="0"
                                flex="1"
                                fontWeight="bold"
                                style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                            >
                                <LuBold />
                            </Button>
                            <Button
                                size="sm"
                                onClick={() => handleFormatChange(index, 'italic')}
                                bg={buttonData.italic ? 'blue.100' : 'white'}
                                borderRadius="0"
                                flex="1"
                                fontStyle="italic"
                                style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                            >
                                <LuItalic />
                            </Button>
                            <Button
                                size="sm"
                                onClick={() => handleFormatChange(index, 'underline')}
                                bg={buttonData.underline ? 'blue.100' : 'white'}
                                borderLeftRadius="0"

                                flex="1"
                                textDecoration="underline"
                                style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                            >
                                <LuUnderline />
                            </Button>
                        </Flex>
                    </FormControl>
                </Flex>

                <FormControl mt={3} display="flex" alignItems="center">
                    <Checkbox
                        isChecked={buttonData.addBorder}
                        onChange={(e) => handleBorderToggle(index, e.target.checked)}
                        colorScheme="blue"
                    />
                    <FormLabel htmlFor="border-toggle" mb="0" ml={2} fontSize="sm">
                        Add Border
                    </FormLabel>
                </FormControl>

                {buttonData.addBorder && (
                    <Flex mt={3} mb={2} gap={2} flexWrap="wrap">
                        <FormControl maxW="120px">
                            <FormLabel fontSize="xs" mb={1}>Border Color</FormLabel>
                           <Flex style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white" }}>
                                <Input
                                    type="text"
                                    value={buttonData.borderColor}
                                    size="sm"
                                    onChange={(e) => updateButtonProp(index, 'borderColor', e.target.value)}
                                    width="100px"
                                    style={{ border: "none" }}
                                />
                                <Input
                                    type="color"
                                    value={buttonData.borderColor}
                                    size="sm"
                                    p={0}
                                    height="32px"
                                    width="32px"
                                    ml={1}
                                    style={{ border: "none" }}
                                    onChange={(e) => updateButtonProp(index, 'borderColor', e.target.value)}
                                />
                            </Flex>
                        </FormControl>

                        <FormControl maxW="120px">
                            <FormLabel fontSize="xs" mb={1}>Border Weight</FormLabel>
                            <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                                <NumberInput
                                    value={buttonData.borderWeight}
                                    min={0}
                                    max={10}
                                    onChange={(value) => updateButtonProp(index, 'borderWeight', value)}
                                    style={{ border: "none !important" }}
                                >
                                    <NumberInputField />
                                    {/* <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper> */}
                                </NumberInput>
                               <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                            </InputGroup>
                        </FormControl>
                    </Flex>
                )}

                <Text
                    mt={3}

                    variant="outline"
                    size="xs"
                    color="blue.500"
                    onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                    style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                >
                    {showAdvancedOptions ? <LuChevronUp /> : <LuChevronDown />}<span style={{ marginLeft: "3px" }}>{showAdvancedOptions ? "Hide" : "Show"} Advanced Options</span>
                </Text>

                <Collapse in={showAdvancedOptions} animateOpacity>
                    <Flex mt={4} gap={2} wrap="wrap">
                        <FormControl maxW="120px">
                            <FormLabel fontSize="xs" mb={1}>Margin Top</FormLabel>
                            <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                                <NumberInput
                                    value={buttonData.marginTop}
                                    min={0}
                                    max={100}
                                    onChange={(value) => updateButtonProp(index, 'marginTop', value)}
                                    style={{ border: "none !important" }}
                                >
                                    <NumberInputField />
                                    {/* <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper> */}
                                </NumberInput>
                                <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                            </InputGroup>
                        </FormControl>

                        <FormControl maxW="120px">
                            <FormLabel fontSize="xs" mb={1}>Margin Right</FormLabel>
                            <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                                <NumberInput
                                    value={buttonData.marginRight}
                                    min={0}
                                    max={100}
                                    onChange={(value) => updateButtonProp(index, 'marginRight', value)}
                                    style={{ border: "none !important" }}
                                >
                                    <NumberInputField />
                                    {/* <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper> */}
                                </NumberInput>
                                <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                            </InputGroup>
                        </FormControl>

                        <FormControl maxW="120px">
                            <FormLabel fontSize="xs" mb={1}>Margin Bottom</FormLabel>
                            <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                                <NumberInput
                                    value={buttonData.marginBottom}
                                    min={0}
                                    max={100}
                                    onChange={(value) => updateButtonProp(index, 'marginBottom', value)}
                                    style={{ border: "none !important" }}
                                >
                                    <NumberInputField />
                                    {/* <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper> */}
                                </NumberInput>
                                <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                            </InputGroup>
                        </FormControl>

                        <FormControl maxW="120px">
                            <FormLabel fontSize="xs" mb={1}>Margin Left</FormLabel>
                            <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                                <NumberInput
                                    value={buttonData.marginLeft}
                                    min={0}
                                    max={100}
                                    onChange={(value) => updateButtonProp(index, 'marginLeft', value)}
                                    style={{ border: "none !important" }}
                                >
                                    <NumberInputField />
                                    {/* <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper> */}
                                </NumberInput>
                                <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                            </InputGroup>
                        </FormControl>
                    </Flex>
                </Collapse>
            </Box>
        );
    };

    return (
        <Box>
            <Flex mb={4} gap={4}>
                <FormControl maxW="175px">
                    <FormLabel fontSize="sm">No of Buttons</FormLabel>
                    <Flex>
                        <Button
                            flex="1"
                            onClick={() => handleButtonCountChange(1)}
                            bg={buttonCount === 1 ? 'blue.100' : 'white'}
                            borderRadius="md"
                            borderRightRadius="0"
                            size="sm"
                            style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                        >
                            1
                        </Button>
                        <Button
                            flex="1"
                            onClick={() => handleButtonCountChange(2)}
                            bg={buttonCount === 2 ? 'blue.100' : 'white'}
                            borderRadius="0"
                            size="sm"
                            style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                        >
                            2
                        </Button>
                     
                        <Button
                            flex="1"
                            onClick={() => handleButtonCountChange(3)}
                            bg={buttonCount === 3 ? 'blue.100' : 'white'}
                            borderRadius="md"
                            borderLeftRadius="0"
                            size={"sm"}
                            style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                        >
                            3
                        </Button>
                    </Flex>
                </FormControl>

                <FormControl maxW="175px">
                    <FormLabel fontSize="sm">Buttons Placement</FormLabel>
                    <Flex>
                        <Button
                            flex="1"
                            onClick={() => handleButtonPlacementChange('horizontal')}
                            bg={buttonPlacement === 'horizontal' ? 'blue.100' : 'white'}
                            borderRadius="md"
                            borderRightRadius="0"
                            size={"sm"}
                            style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                        >
                            <LuGripHorizontal />
                        </Button>
                        <Button
                            flex="1"
                            onClick={() => handleButtonPlacementChange('vertical')}
                            bg={buttonPlacement === 'vertical' ? 'blue.100' : 'white'}
                            borderRadius="md"
                            borderLeftRadius="0"
                            size={"sm"}
                            style={{ border: "1px solid #CCCCCC", color: "#4A5568" }}
                        >
                            <LuGripVertical />
                        </Button>
                    </Flex>
                </FormControl>
            </Flex>

            <Divider />

            {/* Render button editors based on button count */}
            {buttons.map((buttonData, index) => (
                index < buttonCount && renderButtonEditor(buttonData, index)
            ))}
        </Box>
    );
};

export default ButtonBlockEditor;